angular.module('SpidApp')

.constant('OperationalProductAdapterConfig', {
  name : 'OperationalProduct',
  fields : [
    {
    	local   : 'id',
    	distant : 'id'
    }, {
    	local   : 'label',
    	distant : 'libelle_custom'
    }
  ]
})